import { LicensingService } from ".";
import { DefaultHttpClient } from "../httpClients";
/**
 * Factory for creating ILicensingService instances.
 */

var LicensingServiceFactory =
/** @class */
function () {
  function LicensingServiceFactory() {}
  /**
   * Returns ILicensingService instance based on the specified configuration
   * @param config ILicensingServiceConfiguration to use for returning this licensing service
   * @param accessToken Access token to use for performing the HTTP requests.
   */


  LicensingServiceFactory.GetService = function (config, accessToken) {
    if (config.httpClient === undefined) {
      config.httpClient = new DefaultHttpClient(accessToken);
    }

    return new LicensingService(config);
  };

  return LicensingServiceFactory;
}();

export { LicensingServiceFactory };